import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Chat",
  "use": "Chat-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Chat\"><path fill=\"#fff\" fill-opacity=\".01\" d=\"M0 0h24v24H0z\" /><path d=\"m7 17-3 3V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7Z\" fill=\"#5B5EF9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol